export default __webpack_public_path__ + "static/media/Graphik-Bold.1cfe3bed.woff";